<template>
    <div class="anchor-container">
      <keep-alive>
      <router-view></router-view>
      </keep-alive>
    </div>
</template>

<script>

export default {
  name: "anchor",
  data() {
    return {

    };
  },
  computed: {
  },
  mounted(){

  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
.anchor-container {
  width: 100%;

}
</style>
